import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Select, Space, Tabs, Typography } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { monthNames, roles } from "../../../utils/constants";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";

const { TabPane } = Tabs;

const { Title } = Typography;

const BillingsType = ({
  billings = [],
  refForm,
  name,
  description,
  title = "Règles de facturation",
}) => {
  /*
  * let item = mongoose.Schema({
  month: { type: Number, default: 0 },
  year: { type: Number, default: 0 },
  type: { type: String, default: "unique" }, // unique, multiple
});
  * */
  const [items, setItems] = useState(
    JSON.parse(JSON.stringify(billings === null ? [] : billings)).sort(
      (a, b) => {
        if (a.year === b.year) {
          return a.month - b.month;
        }
        return a.year - b.year;
      },
    ),
  );

  const setValueAntdState = value => {
    refForm.current[`_${name}`] = value;
  };

  useEffect(() => {}, []);

  const addItem = async () => {
    // Sort items by year and month
    const sortedItems = [...items].sort((a, b) => {
      if (a.year === b.year) {
        return a.month - b.month;
      }
      return a.year - b.year;
    });

    let lastItem = sortedItems[sortedItems.length - 1];
    let newMonth, newYear;

    if (!lastItem) {
      // IF none add the current month + 2
      const currentDate = new Date();
      newMonth = currentDate.getMonth() + 2;
      newYear = currentDate.getFullYear();
    } else {
      // IF there is a month add the next month based on this one
      newMonth = lastItem.month + 1;
      newYear = lastItem.year;

      // if last year and current year is after
      if (newYear !== new Date().getFullYear()) {
        newYear = new Date().getFullYear();
      }

      if (newMonth > 12) {
        newMonth = 1;
        newYear += 1;
      }
    }

    const newItems = [
      ...items,
      { month: newMonth, year: newYear, type: "unique" },
    ];
    setItems(newItems);
    setValueAntdState(newItems);
  };

  const deleteItem = async index => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const itemToDelete = items[index];

    // ONLY available if the month has not started !!
    if (
      itemToDelete.year > currentYear ||
      (itemToDelete.year === currentYear && itemToDelete.month > currentMonth)
    ) {
      const newItems = items.filter((_, i) => i !== index);
      setItems(newItems);
      setValueAntdState(newItems);
    }
  };

  const onChangeType = (index, type) => {
    const newItems = JSON.parse(JSON.stringify(items));
    newItems[index].type = type;
    setItems(newItems);
    setValueAntdState(newItems);
  };

  // the select is disabled if the month is current or past !!

  return (
    <div style={{ width: "100%" }}>
      <Title level={5} style={{ marginTop: 0, marginBottom: 8 }}>
        {title}
      </Title>
      {description ? (
        <p style={{ marginBottom: 16, color: "rgba(0, 0, 0, 0.65)" }}>
          {description}
        </p>
      ) : null}
      {items.map((item, index) => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        const isPastOrCurrent =
          item.year < currentYear ||
          (item.year === currentYear && item.month <= currentMonth);

        return (
          <Card
            key={index}
            style={{ marginBottom: 16 }}
            bordered={false}
            title={
              <>
                Pèriode : {monthNames[item.month - 1]} {item.year}
              </>
            }
          >
            <Row gutter={24}>
              <Col span={16} style={{ paddingTop: 0 }}>
                <Space direction={"horizontal"}>
                  Mode:
                  <Select
                    style={{ width: 200 }}
                    disabled={isPastOrCurrent}
                    onChange={value => onChangeType(index, value)}
                    value={item.type}
                  >
                    <Option value="unique">Unique</Option>
                    <Option value="multiple">Multiple</Option>
                  </Select>
                </Space>
              </Col>
              <Col span={8} style={{ textAlign: "right" }}>
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => deleteItem(index)}
                  disabled={isPastOrCurrent} // Same as select disabled
                >
                  Supprimer
                </Button>
              </Col>
            </Row>
          </Card>
        );
      })}

      {onlyRoleMapping([roles.admin, roles.permanance]) && (
        <Button
          type="dashed"
          onClick={addItem}
          style={{ width: "100%", marginTop: 16 }}
          icon={<PlusOutlined />}
        >
          Ajouter une règle de facturation pour le prochain mois
        </Button>
      )}
    </div>
  );
};

export default BillingsType;
